import type { FC } from "react";
import { type UsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { useIntl } from "react-intl";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconCpu2 } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useProcessingUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";

export const ProcessingUsageCard: FC<UsageCardLoaderProps> = ({
  from,
  to,
  interval,
  apiKeyId,
  productId,
  isLoadingSubscriptions,
}) => {
  const intl = useIntl();
  const getName = useProductNames();
  const getDescription = useProductDescriptions();
  const {
    usageSum,
    isLoadingProcessingUsage,
    isErrorProcessingUsage,
  } = useProcessingUsageSum({ from, to, interval, apiKeyId });

  const unitLabel = intl.formatMessage(INTERNATIONALIZED_UNIT_LABELS.minute);

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      icon={<IconCpu2 />}
      iconColor="info.5"
      isError={isErrorProcessingUsage}
      isLoading={isLoadingSubscriptions || isLoadingProcessingUsage}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredProcessing}
      name={getName(TieredPriceProductId.TieredProcessing)}
      description={getDescription(TieredPriceProductId.TieredProcessing)}
    />
  );
};
